import { render, staticRenderFns } from "./RiskMatrix.vue?vue&type=template&id=a86c8b20&"
import script from "./RiskMatrix.vue?vue&type=script&lang=ts&"
export * from "./RiskMatrix.vue?vue&type=script&lang=ts&"
import style0 from "./RiskMatrix.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
